import type { MutationToastMeta } from '@heidi/api/meta';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  updateAutoExtractIntentErrorTitle: {
    defaultMessage: 'Backend Error',
    id: 'PGUtNU9gf5',
  },
});

export const USER_SETTINGS_TOASTS = {
  updateAutoExtractIntent: {
    errorToast: {
      title: messages.updateAutoExtractIntentErrorTitle,
    },
  },
  updateAutoLinkIntent: {
    errorToast: {
      title: messages.updateAutoExtractIntentErrorTitle,
    },
  },
} satisfies Record<string, MutationToastMeta>;
